import { Outlet, Navigate, useLocation } from 'react-router';
import { Loader } from '@f2m3/shared-frontend-ui';
import { useVerificationWall } from '../../hooks/useVerificationWall';

/**
 * Route guard for the account-only pages (profile, orders, downloads, payment
 * returns): a user who still has to confirm their email is sent to the code
 * page and comes back to `state.from` afterwards. Albums and the cart are not
 * behind it — what a pending user sees there is the album wall's call.
 */
const VerificationGuard = () => {
  const { pending, ready } = useVerificationWall();
  const location = useLocation();

  if (!ready) return <Loader />;
  if (pending) return <Navigate to="/verify-email/code" replace state={{ from: location.pathname + location.search }} />;
  return <Outlet />;
};

export default VerificationGuard;
